import { Route, Routes } from "react-router-dom";
import "./axios/axiosSetup";
import "./App.css";
import { useEffect } from "react";
import { setupAxiosInterceptors } from "./axios/axiosSetup";
import { useAuth } from "./hooks/useAuth";
import Login from "./components/Authentification/Login/Login";
import Register from "./components/Authentification/Register/Register";
import Home from "./components/Home/Home";
import BarberHome from "./components/BarberHome/BarberHome";
import ProtectedRoute from "./auth/protectedRoute";
import BarberSettings from "./components/BarberSettings/BarberSettings";

function App() {
  const { userSession, logout } = useAuth();

  useEffect(() => {
    if (userSession) {
      setupAxiosInterceptors(() => userSession?.token || null, logout);
    }
  }, [userSession, logout]);

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/" element={<Home />} />
      <Route
        path="/barber-home"
        element={
          <ProtectedRoute Component={BarberHome} requiredRole="barber" />
        }
      />
      <Route
        path="/barber-settings"
        element={
          <ProtectedRoute Component={BarberSettings} requiredRole="barber" />
        }
      />
    </Routes>
  );
}

export default App;
